// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'
import Cookies from 'js-cookie'
import Login from '../components/Login.vue'
import Search from '../components/Search.vue'

const routes = [
  {
    path: '/',
    redirect: '/login' // 显式指定完整路径
  },
  {
    path: '/login',    // 匹配部署路径下的登录
    name: 'Login',
    component: Login
  },
  {
    path: '/search',   // 匹配部署路径下的搜索
    name: 'Search',
    component: Search,
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  // 显式指定部署路径为 /pc/
  history: createWebHistory('/pc/'),
  routes
})
router.beforeEach((to, from, next) => {
  const fullPath = to.fullPath
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!Cookies.get('user_token')) {
      // 修正此处对象格式
      next({
        path: '/login',
        query: { 
          redirect: fullPath  // 确保冒号后的值存在
        }                     // 闭合对象
      })                      // 闭合next参数
      return
    }
  }
  
  if (to.path === '/pc/login' && Cookies.get('user_token')) {
    next('/pc/search')
    return
  }
  
  next()
})

export default router